<template>
	<div class="extra-bandwidth-container">
		<el-form-item :label="$t('eip.text.bandwidthLimit') | withColon"
			class="slider-form-item-margin-bottom">
			<div class="el-form-item-inline">
				<el-slider v-model="selectBandwidth" show-input 
					:max="200"
					:debounce="1000" 
					:marks="marks"
					:min="formattedMinBandwidth" class="jc-slider-custom"
					:disabled="bandwidthSliderDisabled" 
					@change="emitBandwidthSliderChange">
				</el-slider>
			</div>
			<p class="el-form-item-help">
				{{$t('create.help.ddosVpc')}}
				<a :href="Config.DDOS_URL"
					target="_blank">
					{{ $t('create.help.ddosVpcGuid') }}
				</a>
		  	</p>
		  	<!--基础带宽售罄-->
			<p v-if="bandwidthSliderDisabled"  class="sold-out-tip">
				{{$t('eip.help.bandwidthSoldOut')}}
				<a :href="Config.WOKR_URL" target="_blank">{{$t('create.tooltip.ticket')}}</a>
			</p>

		</el-form-item>
	</div>
</template>

<script>
export default {
	data() {
		return {
			selectBandwidth: this.chooseBandwidth,
			marks: {1:'1Mbps', 200:'200Mbps'}
		};
	},
	model: {
		prop: 'chooseBandwidth',
		event: 'bandwidthEvent'
	},
	props: {
		// 通过接口获得可用带宽值
		bandwidth: {
			type: Number,
			default: 200
		},
		chooseBandwidth: {
			type: Number,
		},
		createOrNot: {
			type:Boolean,
			default:false
		}
	},
	computed: {
		// 格式化后的最小基础带宽值
		formattedMinBandwidth() {
			let formattedBandwidth = 1;
			return formattedBandwidth;
		},
		// 格式化后的最大基础带宽值
		formattedMaxBandwidth() {
			let formattedBandwidth = this.bandwidth > 0 ? this.bandwidth : 1;
			return formattedBandwidth > 200 ? 200 : formattedBandwidth;

		},
		// 基础带宽是否slider是否禁用
		bandwidthSliderDisabled() {
			return this.bandwidth === 0;
		},
	},
	methods: {
		emitBandwidthSliderChange(val) {
			this.$emit('bandwidthEvent',val);
		}
	}
};
</script>

<style lang="scss">
	.extra-bandwidth-container {
		.slider-form-item-margin-bottom {
			margin-bottom: 10px!important;
		}
		.sold-out-tip{
			color:red !important;
			margin-top:10px !important
		}

		.higher-custom-tip{
			height:30px;
			width:350px
		}

		.el-form-item .el-form-item-help{
			margin-top: 20px !important;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/common/extraBandwidth/ExtraBandwidth.vue